import { useEffect } from "react";

import { useUiStore } from "@/store/uiStore";

export function useTheme() {
  const theme = useUiStore((state) => state.theme);
  const setTheme = useUiStore((state) => state.setTheme);

  useEffect(() => {
    const root = document.documentElement;
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const shouldUseDark = theme === "system" ? prefersDark : theme === "dark";

    root.classList.toggle("dark", shouldUseDark);
  }, [theme]);

  return { theme, setTheme };
}
